import { render, staticRenderFns } from "./answerReport.vue?vue&type=template&id=bef3401a&scoped=true"
import script from "./answerReport.vue?vue&type=script&lang=ts"
export * from "./answerReport.vue?vue&type=script&lang=ts"
import style0 from "./answerReport.vue?vue&type=style&index=0&id=bef3401a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef3401a",
  null
  
)

export default component.exports